<!--  -->
<template>
  <div class="title-box">
     <div class="chinese-title">{{chineseTitle}}</div>
     <div class="en-title">{{enTitle}}</div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  },

  props: ["chineseTitle", "enTitle"],

  watch: {},

  components: {},

  computed: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
.title-box {
   text-align: center;
  .chinese-title {
    color: #333;
    font-size: 28px;
    line-height: 40px;
    font-weight: bold;
  }
  .en-title {
    color: #999;
    font-size:14px;
    line-height: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header/title.vue